<template>
  <div class="description-box-wrapper">

    <div class="info-window">
      <div class="header"></div>
      <div v-if="!showEndScreen" class="info-content">

        <h2 class="question-title">VRAAG {{ currentQuestionIndex + 1 }}</h2>
        <!--Quest media item-->
        <div class="row image mt-3"
             v-if="currentQuestion.mediaItem && currentQuestion.mediaItem.type !== mediaItemTypeEnum.none">

          <div class="activity-image"
               v-if="currentQuestion.mediaItem.type === mediaItemTypeEnum.image && currentQuestion.mediaItem.imageAsset">
            <img class="img-fluid" :src="currentQuestion.mediaItem.imageAsset.url" alt="Activiteit afbeelding"/>
          </div>

          <div class="embed-responsive embed-responsive-16by9 activity-video"
               v-if="currentQuestion.mediaItem.type === mediaItemTypeEnum.video && currentQuestion.mediaItem.videoUrl">

            <iframe class="embed-responsive-item"
                    :src="convertYoutubeUrlToEmbedUrl(currentQuestion.mediaItem.videoUrl)"
                    title="YouTube video player"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
          </div>
        </div>

        <div class="description">
          <p>{{ currentQuestion.phrase }}</p>

          <div v-if="currentQuestion.possibleAnswers" class="answers">
            <p :class="getTextColor(0)">A: {{ currentQuestion.possibleAnswers[0] }}</p>
            <p :class="getTextColor(1)">B: {{ currentQuestion.possibleAnswers[1] }}</p>
            <p :class="getTextColor(2)">C: {{ currentQuestion.possibleAnswers[2] }}</p>
            <p :class="getTextColor(3)">D: {{ currentQuestion.possibleAnswers[3] }}</p>
          </div>

        </div>

      </div>

      <div v-if="showEndScreen" class="info-content">
        <div class="description">
          <p class="score-title text-center">EINDSCORE</p>
          <p class="score text-center">{{ score }}/{{ quizQuestions.length }}</p>

          <h2 class="results-title">RESULTATEN</h2>
          <div class="result-inputs">
            <div v-for="result in activity.quest.questResults" :key="result.id" class="result-input-wrapper">
              <div v-if="result.format === 'text'" class="text-input-wrapper">
                <p>{{ result.label }}</p>
                <input type="text" class="result-input text-input" placeholder="" :data-id="result.id"
                       :data-format="result.format" :data-label="result.label">
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="footer"></div>

      <div v-if="!showEndScreen" class="button-row">
        <QuizAnswerButton :answerIndex="0" :selected="selectedAnswerIndex === 0"
                          :isCorrect="currentQuestion.correctAnswerIndex === 0" :showResult="showResult"
                          @answerClicked="answerClicked"></QuizAnswerButton>
        <QuizAnswerButton :answerIndex="1" :selected="selectedAnswerIndex === 1"
                          :isCorrect="currentQuestion.correctAnswerIndex === 1" :showResult="showResult"
                          @answerClicked="answerClicked"></QuizAnswerButton>
        <QuizAnswerButton :answerIndex="2" :selected="selectedAnswerIndex === 2"
                          :isCorrect="currentQuestion.correctAnswerIndex === 2" :showResult="showResult"
                          @answerClicked="answerClicked"></QuizAnswerButton>
        <QuizAnswerButton :answerIndex="3" :selected="selectedAnswerIndex === 3"
                          :isCorrect="currentQuestion.correctAnswerIndex === 3" :showResult="showResult"
                          @answerClicked="answerClicked"></QuizAnswerButton>
      </div>

      <WhiteOutlineButton v-if="!showResult && !showEndScreen" class="confirm-answer-button"
                          :button-text="'ANTWOORD BEVESTIGEN'"
                          v-on:clicked="confirmAnswerClicked"></WhiteOutlineButton>

      <WhiteOutlineButton v-show="showResult && !(currentQuestionIndex === quizQuestions.length-1)"
                          class="confirm-answer-button" :button-text="'VOLGENDE VRAAG'"
                          v-on:clicked="nextQuestionClicked"></WhiteOutlineButton>

      <WhiteOutlineButton v-if="showResult && (currentQuestionIndex === quizQuestions.length-1)"
                          class="confirm-answer-button" :button-text="'RESULTAAT BEKIJKEN'"
                          v-on:clicked="showEndResultClicked"></WhiteOutlineButton>

      <WhiteOutlineButton v-if="showEndScreen"
                          class="confirm-answer-button" :button-text="'AFSLUITEN'"
                          v-on:clicked="closeClicked"></WhiteOutlineButton>

      <button class="btn cancel-activity-button" v-on:click="cancelActivityClicked">Activiteit annuleren</button>

    </div>

  </div>
</template>

<script>

import { QuestMediaTypeEnum } from "sandpiper_api";

import QuestPropertiesHelper from "@/mixins/QuestPropertiesHelper";
import YoutubeVideoEmbedder from "@/mixins/YoutubeVideoEmbedder";

import WhiteOutlineButton from "@/components/StudentPlatform/WhiteOutlineButton";
import QuizAnswerButton from "@/components/StudentPlatform/Activities/QuizAnswerButton";


export default {
  name: "Quiz",
  components: { WhiteOutlineButton, QuizAnswerButton },
  emits: [ "confirmAnswerClicked", "cancelActivityClicked" ],
  props: {
    name: String,
    open: Boolean,
    quizQuestions: Array,
    activity: Object,
  },
  mixins: [ QuestPropertiesHelper, YoutubeVideoEmbedder ],
  inject: [ "doApiRequest" ],
  data()
  {
    return {
      mediaItemTypeEnum: new QuestMediaTypeEnum(),
      currentQuestionIndex: 0,
      score: 0,
      selectedAnswerIndex: null,
      showResult: false,
      showEndScreen: false,
    }
  },
  computed: {
    currentQuestion()
    {
      return this.quizQuestions[this.currentQuestionIndex];
    }
  },
  methods: {
    answerClicked(index)
    {
      this.selectedAnswerIndex = index;
    },

    confirmAnswerClicked()
    {
      if (this.selectedAnswerIndex !== null)
      {
        this.showResult = true;

        if (this.currentQuestion.correctAnswerIndex === this.selectedAnswerIndex)
        {
          this.score++;
        }
      }
    },

    nextQuestionClicked()
    {
      this.currentQuestionIndex++;
      this.selectedAnswerIndex = null;
      this.showResult = false;
    },

    showEndResultClicked()
    {
      this.showResult = false;
      this.showEndScreen = true;
    },

    closeClicked()
    {
      console.log("closeClicked");
      this.currentQuestionIndex = 0;
      this.score = 0;
      this.selectedAnswerIndex = null;
      let data = {
        activityId: this.activity.id,
        results: this.getResults(),
      };
      this.$emit("completeActivityClicked", data);
    },

    cancelActivityClicked()
    {
      this.$emit("cancelActivityClicked");
    },

    getTextColor(id)
    {
      if (this.showResult)
      {
        if (this.selectedAnswerIndex === id && !(this.currentQuestion.correctAnswerIndex === id))
        {
          return 'redText';
        }
        else if ((this.currentQuestion.correctAnswerIndex === id))
        {
          return 'greenText';
        }
      }
      else
      {
        return '';
      }
    },

    getResults()
    {
      let results = [];
      document.querySelectorAll('.result-input').forEach(resultEl =>
      {
        console.log(resultEl);
        let result = {
          format: resultEl.dataset.format,
          resultValue: resultEl.value,
          label: resultEl.dataset.label,
        };
        results.push(result);
      });

      return results;
    },

  }
}
</script>

<style lang="scss" scoped>

::-webkit-scrollbar {
  display: none;
}

.info-window {

  position: relative;

  .header {
    background-image: url("~@/assets/image/platform/frame/frame_medium_top.svg");
    background-size: 100%;
    background-repeat: no-repeat;
    background-position: bottom center;
    height: min(5vw, 11vh);
    top: 1px;
    position: relative;
  }

  .info-content {
    background-image: url("~@/assets/image/platform/frame/frame_medium_mid.svg");
    background-size: 100%;
    background-position: center center;
    position: relative;
    padding: 0px 25px 25px 25px;

  }

  .footer {
    background-image: url("~@/assets/image/platform/frame/frame_medium_bot.svg");
    background-size: 100%;
    background-repeat: no-repeat;
    background-position: top center;
    height: min(5vw, 11vh);
  }

}

.activity-detail {
  padding-top: 6%;
  margin: 0 2rem;
  margin-bottom: 2rem;
  height: 100%;
  overflow-y: scroll;
}

.description-box {
  width: 100%;
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center center;
}

.start-activity-button {
  margin-bottom: 30px;
}

.cancel-activity-button {
  display: block;
  text-decoration: underline;
  color: white;
  margin: 0 auto;
  margin-top: 30px;
}

.description-box-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
  flex: 0 0 60%;
  max-width: 900px;
}

.description {
  width: 100%;
  height: 50%;
  overflow-y: scroll;
  padding: 0 25px;
  text-align: center;
  font-size: 1.3rem;

  p {
    margin-top: 15px;
    color: white;
    white-space: pre-line;

  }

  .score-title {
    margin: 0;
    font-size: 2rem;
    font-weight: bold;
  }

  .score {
    margin: 0;
    font-size: 6rem;
    font-weight: bold;
  }

  .results-title {
    color: white;
  }
}

.question-title {
  font-size: 2rem;
  font-weight: bold;
  text-align: center;
  color: white;
}

.confirm-answer-button {
  min-width: 350px;
  width: 50%;
  height: 60px;
  margin: 0 auto;
  margin-top: 2rem;
}

.button-row {
  height: 15%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.redText {
  color: $activity-orange !important;
}

.greenText {
  color: $activity-green !important;
}

.image {
  justify-content: center;
}

.activity-image {
  display: flex;
  justify-content: center;
}
</style>